exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".accordion .accordion-section{border-top:1px solid #ddd;padding:20px 8px}.accordion .accordion-section .header-content{flex-grow:2}.accordion .accordion-section .body-content{max-height:0;transition:max-height .33s;overflow-y:hidden}.accordion .accordion-section .header-arrow{display:flex;align-items:center}.accordion .accordion-section .header-arrow .arrow-indicator{transition:transform .33s}.accordion .accordion-section.expanded .header-arrow .arrow-indicator{transform:rotate(180deg)}.accordion .accordion-section.expanded .body-content{display:block;max-height:300px}.accordion .accordion-no-border{border-top:0!important}", ""]);

// exports
